import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { LoaderPopConfig, LoaderPopService } from 'src/components/loader-pop/loader-pop.service';
import { MessagePopConfig, MessagePopConstants, MessagePopService } from 'src/components/message-pop/message-pop.service';


export interface HttpCustomOptions {
  createLoaderAction: boolean
  showErrorMessage: boolean
  showSuccessMessage: boolean
  errorMessage?: string
  successMessage?: string
}


@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService {

  constructor(private http: HttpClient, private loaderPopService: LoaderPopService, private messagePopService: MessagePopService, private router: Router) { }

  get<T>(url: string, options?: object, customOptions?: HttpCustomOptions): Observable<T> {
    this.requestHandle(customOptions);
    return this.http.get<T>(url, options).pipe(
      tap(
        (success) => this.handleSuccess(success, customOptions),
        (error) => this.handleError(error, customOptions)
      )
    );
  }

  post<T>(url: string, body: any, options?: object, customOptions?: HttpCustomOptions): Observable<T> {
    this.requestHandle(customOptions);
    return this.http.post<T>(url, body, options).pipe(
      tap(
        (success) => this.handleSuccess(success, customOptions),
        (error) => this.handleError(error, customOptions)
      )
    );
  }

  put<T>(url: string, body: any, options?: object, customOptions?: HttpCustomOptions): Observable<T> {
    this.requestHandle(customOptions);
    return this.http.put<T>(url, body, options).pipe(
      tap(
        (success) => this.handleSuccess(success, customOptions),
        (error) => this.handleError(error, customOptions)
      )
    );
  }

  delete<T>(url: string, options?: object, customOptions?: HttpCustomOptions): Observable<T> {
    this.requestHandle(customOptions);
    return this.http.delete<T>(url, options).pipe(
      tap(
        (success) => this.handleSuccess(success, customOptions),
        (error) => this.handleError(error, customOptions)
      )
    );
  }

  patch<T>(url: string, body: any, options?: object, customOptions?: HttpCustomOptions): Observable<T> {
    return this.http.patch<T>(url, body, options).pipe(
      tap(
        (success) => this.handleSuccess(success, customOptions),
        (error) => this.handleError(error, customOptions)
      )
    );
  }

    private async handleError(response: any, customOptions?: HttpCustomOptions) {
      if(customOptions?.createLoaderAction){
        const loaderConfig: LoaderPopConfig = {
          createAction: false
        }
        this.loaderPopService.notifySubject.next(loaderConfig)
      }
      if(customOptions?.showErrorMessage){
        const messageConfig: MessagePopConfig = {
          subject : 'Failed! ',
          message: customOptions.errorMessage || response?.error?.message || 'Some error occurred',
          status: MessagePopConstants.FAILURE,
        };
        this.messagePopService.notifySubject.next(messageConfig);
      }
      switch (response.status) {
        case 401:
          // Unauthorized code detected. Calling logout token.
            localStorage.removeItem("idToken");
            this.router.navigate(["/login"])
          break;
        default:
          break;
      }
    }

    private async handleSuccess(response: any, customOptions?: HttpCustomOptions) {
      if(customOptions?.createLoaderAction){
        const loaderConfig: LoaderPopConfig = {
          createAction: false
        }
        this.loaderPopService.notifySubject.next(loaderConfig)
      }
      if(customOptions?.showSuccessMessage){
        const messageConfig: MessagePopConfig = {
          subject : "Success!",
          message: customOptions?.successMessage || response?.message || '',
          status: MessagePopConstants.SUCCESS,
        };
        this.messagePopService.notifySubject.next(messageConfig);  
      }
    }

    private async requestHandle(customOptions?: HttpCustomOptions){
      if(customOptions?.createLoaderAction){
        const loaderConfig: LoaderPopConfig = {
          createAction: true
        }
        this.loaderPopService.notifySubject.next(loaderConfig)
      }
    }
}
